import { Ref, WatchStopHandle } from 'vue';
import BaseService, { getInstance } from '../base-service';
import WeMapBaseLayer  from '@tlbs/wemap-base-layer';
import { MessagePlugin } from 'tdesign-vue-next';
const REQUESTS = getInstance() || new BaseService();
export default async function useBaseMapLayer(
  mapInstance: LooseObject,
  layerInfo: Ref<MapLayer<BaseConfig>>,
) {
  if (!layerInfo.value || !layerInfo.value.config) return;
  let unwatchList: WatchStopHandle[] | null = [];
  let wemapBaseLayer:(LooseObject) = {};
  const { id, zIndex } = layerInfo.value;
  const { id: mapId, name } = layerInfo.value.config.data || {};
  if (mapId && name) {
    wemapBaseLayer = await handleData(mapInstance, id, zIndex, layerInfo.value.config.data || {});
  }
  unwatchList.push(watch(() => layerInfo.value, async () => {
    const { id: mapIds, name } = layerInfo?.value?.config?.data || {};
    console.log('更改wemapBaseLayer', layerInfo?.value?.config?.data);
    Object.values(wemapBaseLayer).forEach((layer) => {
      layer?.destroy?.();
      layer?.unmount?.();
    });
    if (mapIds && name) {
      wemapBaseLayer = await handleData(mapInstance, mapIds, zIndex,  layerInfo.value.config.data || {});
    }
  }, { deep: true }));
  wemapBaseLayer.unmount = (): void => {
    Object.values(wemapBaseLayer).forEach(layer => layer?.unmount?.());
    Object.values(wemapBaseLayer).forEach(layer => layer?.destroy?.());
    // wemapBaseLayer?.HDRoadModel?.destroy?.();
    wemapBaseLayer = {};
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };
  return wemapBaseLayer;
}
const handleData = async (mapInstance: LooseObject, id: string, zIndex: number, options: LooseObject) => {
  const { id: mapId, layerName } = options;
  try {
    // 1、获取地图包含几个图层
    const mapLayerList = await REQUESTS.getMapLayerList(mapId);
    console.log('----mapLayerList----------', mapId, mapLayerList);
    if (!mapLayerList?.data?.length) {
      MessagePlugin.warning({ content: `拉取${layerName ? layerName : ''}图层的数据为空，请检查图层内容` });
      return {};
    }
    const res = mapLayerList.data.some((layer: { isNeedPolicy: boolean; }) => layer.isNeedPolicy);
    if (res) {
      console.error('暂不支持点聚合地图效果');
    }
    // 2、获取地图中心坐标、底图样式、默认缩放层级
    const mapDetail = await REQUESTS.getMapDetail(mapId);
    const { basemapType, centerCoordinates, zoom } = mapDetail.data || {};
    const [latitude, longitude] = centerCoordinates?.split(' ') || [40.040452, 116.273486];
    mapInstance?.setMapStyleId(basemapType || 'FROST_WHITE');
    mapInstance?.setCenter(new TMap.LatLng(latitude, longitude));
    zoom && mapInstance?.setZoom(zoom);
    const { dataSource2 } = REQUESTS.getDomain();
    let baseURL = dataSource2?.service?.defaults?.baseURL || 'https://testservice.wemap.qq.com';
    const debug = baseURL.indexOf('test') !== -1;
    baseURL = `${baseURL}/base`;
    console.log('渲染地图id', mapId);
    const wemapBaseLayers:(LooseObject) = {};
    wemapBaseLayers[mapId] = new WeMapBaseLayer(mapInstance, {
      httpReq: {
        reqConfig: {
          baseURL,
        } },
      mapProjectId: mapId,
      debug,
    });
    return wemapBaseLayers;
  } catch (err) {
    console.error(err);
    MessagePlugin.warning({ content: `拉取${layerName ? layerName : ''}图层失败` });
    return {};
  }
};

